import { createSelector } from '@reduxjs/toolkit';
import {
  AUTH_STATUS_AUTHENTICATED,
  AUTH_STATUS_BOOTSTRAPPING,
  GUEST_MINT_STATUS_FAILED,
} from '../types/user';
import { userIdSelector } from './user.selector';

/**
 *
 * @returns
 */
export const auth = (state) => state.auth;

/**
 * Returns current browser authentication lifecycle state.
 * @param {import('global').ReduxAppState} state
 * @returns {string}
 */
export const selectAuthStatus = createSelector(
  [auth],
  (item) => item?.status ?? AUTH_STATUS_BOOTSTRAPPING
);

/**
 * Returns true only after authentication bootstrap has authenticated user.
 * @param {import('global').ReduxAppState} state
 * @returns {boolean}
 */
export const selectIsAuthenticated = createSelector(
  [selectAuthStatus],
  (status) => status === AUTH_STATUS_AUTHENTICATED
);

/**
 * Returns the in-memory authentication session generation.
 * @param {import('global').ReduxAppState} state
 * @returns {number}
 */
export const selectAuthSessionEpoch = createSelector(
  [auth],
  (item) => item?.authSessionEpoch ?? 0
);

/**
 *
 */
export const selectIsGimConnected = createSelector(
  auth,
  (item) => item.isGimConnected
);

/**
 * @type {import('reselect').Selector<import('reselect').RootStateSelectors, boolean>}
 */
export const selectIsAdmin = createSelector([auth], (item) => item.isAdmin);

/**
 *
 */
export const selectUserRole = createSelector([auth], (item) => item.userRole);

/**
 * Holds public app routes until a signed-in user id or a guest token exists.
 * @param {import('global').ReduxAppState} state
 * @returns {'hold' | 'ready' | 'error'}
 */
export const selectPublicCredentialGate = createSelector(
  [auth, userIdSelector],
  (authState, userId) => {
    const guestToken = authState?.guestToken || '';
    const accessToken = authState?.authToken || '';
    if ((userId ?? 0) > 0 || guestToken !== '') return 'ready';
    if (
      authState?.guestMintStatus === GUEST_MINT_STATUS_FAILED &&
      accessToken === '' &&
      guestToken === ''
    ) {
      return 'error';
    }
    return 'hold';
  }
);
